export const normalizePromotionLabelOptions = raw => {
  const list = Array.isArray(raw) ? raw : [];
  const seen = new Set();
  const options = [];

  for (const item of list) {
    const value = String(item?.promotionLabel || item?.text || item?.label || item?.value || item || '').trim();
    if (!value || seen.has(value)) {
      continue;
    }

    seen.add(value);
    options.push({
      value,
      label: value,
    });
  }

  options.sort((a, b) => a.label.localeCompare(b.label));
  return options;
};

export const getPromotionLabelTone = label => {
  const value = String(label || '')
    .trim()
    .toLowerCase();
  if (!value) return 'default';
  if (value.includes('config missing') || value.includes('config overlap')) return 'error';
  if (value.includes("don't promote")) return 'error';
  if (value.includes('review') || value.includes('hold')) return 'warning';
  if (value.includes('promote')) return 'success';
  return 'default';
};

export const getPromotionLabelTextColor = label => {
  const tone = getPromotionLabelTone(label);
  if (tone === 'error') return 'error.main';
  if (tone === 'warning') return 'warning.main';
  if (tone === 'success') return 'success.main';
  return 'text.primary';
};
